const staticPixels = "\n<script async src=\"https://www.googletagmanager.com/gtag/js?id=G-W6FD9FK0F1&l=dataLayer\"></script>\n<script async src=\"https://www.googletagmanager.com/gtag/js?id=G-DM02071GE3&l=dataLayer\"></script>\n<script async src=\"https://www.googletagmanager.com/gtag/js?id=G-1K6FDQTJVT&l=dataLayer\"></script>";
const pixelsCategories = ["STRICTLY_NECESSARY","TARGETING","FUNCTIONAL"];

export { staticPixels };
export { pixelsCategories };